<template>
  <base-page-layout title="Listagem de produtos" :hideBreadcrumbs="false">
    <mf-tabs-menu v-model="tab" :tabs="tabs" class="mb-5" />
    <router-view />
  </base-page-layout>
</template>

<script>
export default {
  components: {
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
  },
  data: () => ({
    tab: 0,
  }),
  computed: {
    tabs() {
      const isClub = this.$getLoggedUser().has_club
      const isEcommerce = this.$getLoggedUser().has_ecommerce
      const isPhygital = isClub && isEcommerce
      if ((isPhygital || isEcommerce) && this.$getAllowedModules()['manage_products']) {
        return [
          {
            name: 'Produtos',
            haveLength: false,
            to: '/produtos/gerenciamento-produtos',
          },
          {
            name: 'Produtos Lojas',
            haveLength: false,
            to: '/produtos/gerenciamento-produtos/produtos-loja',
          },
          {
            name: 'Grupos',
            haveLength: false,
            to: '/produtos/gerenciamento-produtos/grupos',
          },
        ]
      }
      return [
        {
          name: 'Produtos',
          haveLength: false,
          to: '/produtos/gerenciamento-produtos',
        },
        {
          name: 'Grupos',
          haveLength: false,
          to: '/produtos/gerenciamento-produtos/grupos',
        },
      ]
    },
  },
  watch: {
    tab(tab) {
      if (this.$route.path !== this.tabs[tab].to) {
        this.$router.push(this.tabs[tab].to).catch(() => {})
      }
    },
  },
  mounted() {
    this.setInitialTab()
  },
  beforeUpdate() {
    this.setInitialTab()
  },
  methods: {
    setInitialTab() {
      if (this.$route.path === '/produtos/gerenciamento-produtos') {
        this.$router.push(this.tabs[0].to).catch(() => {})
        this.tab = 0
        return
      }
      const index = this.tabs.findIndex((p) => p.to === this.$route.path)
      this.tab = index === -1 ? 0 : index
    },
  },
}
</script>
